module.exports = __webpack_public_path__ + "3140900753cc4e4c28b632f037746698.svg";